export default __webpack_public_path__ + "static/media/image-1.1.fe187804.jpg";